/**
 * Hybrid AccordionContent.
 * Automatically chooses between the Tailwind and styled-components rendering
 * based on whether styled-system props or a styled() extension are present.
 */

import React, { useContext } from "react";
import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import { StyledRadixAccordionContent, ContentContainer } from "./styles";
import { AccordionContext } from "./Accordion";
import { AccordionContentTailwind } from "./AccordionContentTailwind";
import { type TypeAccordionSystemProps } from "./AccordionTypes";

interface TypeAccordionContentProps extends TypeAccordionSystemProps {
  children?: React.ReactNode;
}

export const AccordionContentHybrid = ({
  children,
  ...rest
}: TypeAccordionContentProps) => {
  const { styled } = useContext(AccordionContext);

  if (needsStyledComponents(rest)) {
    // Styled-components branch — identical to the legacy AccordionContent body.
    return (
      <StyledRadixAccordionContent data-styled={styled}>
        <ContentContainer data-styled={styled} {...rest}>
          {children}
        </ContentContainer>
      </StyledRadixAccordionContent>
    );
  }

  // Tailwind path (preferred — no styled-components runtime).
  return (
    <AccordionContentTailwind {...rest}>{children}</AccordionContentTailwind>
  );
};
